export default function getCalendarFeedUrl({ token }) {
  const apiUrl = (process.env.API_URL || '').replace('https://', 'http://').replace('http://', 'webcal://');
  return `${apiUrl}/calendarfeed?token=${encodeURIComponent(token)}`;
}
